import AuthImage from './AuthImage';

/**
 * Profile photo loaded through the authenticated `/api/users/:id/selfie` proxy
 * so private S3 buckets still work (unlike a bare public URL).
 */
export default function SelfieImage({ userId, hasPhoto, alt = '', className, placeholder }) {
  if (!userId || !hasPhoto) {
    return placeholder || null;
  }
  return <AuthImage path={`/users/${userId}/selfie`} alt={alt} className={className} />;
}
